import axios from "axios";
import { getAccessToken } from "../utils";
import config from "../config";
import { handleApiError } from "../components/errorBoundary/errorUtils";

const currentDomain = process.env.REACT_APP_DOMAIN;
const domainConfig = config[currentDomain];
const endpoint = domainConfig.apiEndpoint;

async function apiCallToSaveDatapoint(datasetID, formdata) {
  try {
    var access_token = getAccessToken();
    const response = await axios.post(
      `${endpoint}project/datapoint/${datasetID}`,
      formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("error making the api call to the aerver");
    return handleApiError(error);
  }
}

async function putDatapoint(datasetID, datapointID, formdata) {
  try {
    var access_token = getAccessToken();
    const response = await axios.put(
      `${endpoint}project/dataset/${datasetID}/datapoint/${datapointID}`,
      formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${access_token}`,
        },
      }
    );
    return response;
  } catch (error) {
    return handleApiError(error);
  }
}

async function populateWithPresignedURL(file_path) {
  const access_token = getAccessToken();
  const cleanPath = file_path.replace(/^https?:\/\/[^/]+/, "");
  const response = await axios.get(
    `${endpoint}project/generate-presigned-url?s3_file_path=${cleanPath}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${access_token}`,
      }
    }
  );
  
  let parsed_response;
  if (typeof response.data.form_data === 'string') {
    parsed_response = JSON.parse(response.data.presigned_url);
  } else {
    parsed_response = response.data.presigned_url;
  }
    return parsed_response

}

async function getAllDataPoints(
  dataset_id,
  rowsPerPage,
  pageNumber,
  sortKey,
  sortBy,
  handleLogout
) {
  try {
    var access_token = getAccessToken();

    const queryParams = [];
    if (pageNumber + 1) {
      queryParams.push(`page=${pageNumber + 1}`);
    }
    if (rowsPerPage) {
      queryParams.push(`page_size=${rowsPerPage}`);
    }
    if (sortKey) {
      queryParams.push(`sort_key=${sortKey}`);
    }
    if (sortBy) {
      queryParams.push(`sort_by=${sortBy}`);
    }
    const queryString =
      queryParams.length > 0 ? `?${queryParams.join("&")}` : "";

    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + access_token,
      },
    };
    const response = await axios.get(
      `${endpoint}project/datapoint/${dataset_id}${queryString}`,
      {
        headers: {
          Authorization: "Bearer " + access_token,
        },
      }
    );
    return response.data;
  } catch (error) {
    return handleApiError(error);
  }
}

export { getAllDataPoints, apiCallToSaveDatapoint, putDatapoint, populateWithPresignedURL };
